import type { ActionMenuItem } from '@/shared/components';
import type { apartmentLifecycleUi } from './apartmentLifecycleUi';

interface Handlers {
  onEditMasterData: () => void;
  onLifecycle: () => void;
  onArchive: () => void;
}

/**
 * Die Einträge des Aktionsmenüs der Apartmentakte.
 *
 * <p>Nur was erlaubt ist, steht drin (§10) — eine abgeblendete destruktive Fläche liest sich wie
 * ein Fehler (Lehre aus Block E).</p>
 */
export function apartmentActionMenu(
  lifecycle: ReturnType<typeof apartmentLifecycleUi>,
  handlers: Handlers,
): ActionMenuItem[] {
  return [
    { label: 'Stammdaten ändern', icon: 'Edit', onClick: handlers.onEditMasterData },
    ...(lifecycle.lifecycleAction
      ? ([
          {
            label:
              lifecycle.lifecycleAction === 'pause'
                ? 'Apartment pausieren'
                : 'Apartment fortsetzen',
            icon: lifecycle.lifecycleAction === 'pause' ? 'Pause' : 'Play',
            onClick: handlers.onLifecycle,
          },
        ] satisfies ActionMenuItem[])
      : []),
    ...(lifecycle.canArchive
      ? ([
          { separator: true },
          {
            label: 'Apartment archivieren',
            icon: 'Archive',
            destructive: true,
            onClick: handlers.onArchive,
          },
        ] satisfies ActionMenuItem[])
      : []),
  ];
}
